import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQuerySummary} from "@/service/summary.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Card, CardActions, CardContent, Grid, Stack, Typography} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal, useGlobalActions} from "@/store/global.c";
import Chip from "@mui/material/Chip";
import {RecordPO} from "@/model/content";
import {ViewCustomer} from "@/pages/Customer/ViewCustomer";
import {ViewContract} from "@/pages/Contract/ViewContract";
import {ViewChance} from "@/pages/Chance/ViewChance";
import {ViewFieldwork} from "@/pages/Fieldwork/ViewFieldwork";
import {ViewPayback} from "@/pages/Payback/ViewPayback";
import {ViewInvoice} from "@/pages/Invoice/ViewInvoice";
import {ViewPayment} from "@/pages/Payment/ViewPayment";

export const ViewSummary: FC = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: summaryData, isLoading: summaryLoading} = useQuerySummary({id: drawerId!}, isNumber(drawerId))
    const {setDialogModal} = useGlobalActions()
    const summary = summaryData?.data
    const onClickRecord = (type: string, typeId: number, otherId: number) => {
        switch (typeId) {
            case 1:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewCustomer mode={'dialog'}/>})
                break
            case 2:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewChance mode={'dialog'}/>})
                break
            case 3:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewContract mode={'dialog'}/>})
                break
            case 4:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewPayback flag={1} mode={'dialog'}/>})
                break
            case 6:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewInvoice mode={'dialog'}/>})
                break
            case 7:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewFieldwork mode={'dialog'}/>})
                break
            case 8:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewPayment mode={'dialog'}/>})
                break
            case 10:
                setDialogModal({open: true, header: type, maxWidth: 'md', id: otherId, body: <ViewPayback flag={-1} mode={'dialog'}/>})
                break
        }

    }
    return <> <ResultWrapper isLoading={summaryLoading} isEmpty={isEmpty(summary)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'标题'} content={summary?.title}/>
                <GridItem title={'创建人'} content={summary?.creator}/>
                <GridItem title={'总结类型'} content={summary?.category}/>
                <GridItem title={'创建时间'} content={formatTime("D", summary?.createdAt)}/>
                <GridItem title={'是否阅读'} content={summary?.isRead ? '是' : '否'}/>
                <GridItem title={'通话量'} content={summary?.callVolume || '-'}/>
                <GridItem minHeight={'48px'} size={12} title={'工作内容'} content={summary?.content}/>
                <GridItem minHeight={'48px'} size={12} title={'工作计划'} content={summary?.planning}/>
                {summary?.isEvaluate && <GridItem minHeight={'48px'} size={12} title={"回复内容"} content={summary?.reply}/>}
            </Grid>

            {summary?.records?.map((record: RecordPO, index: number) => {
                return <Card key={index} sx={{borderColor: '#f5f5f4', bgcolor: '#f2f2f2', p: 1}}
                             onClick={() => onClickRecord(record.type, record.typeId, record.otherId)}
                             variant='highlighted'>
                    <CardContent>
                        <Typography mb={1} variant="body1" component="div">
                            {record.content}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Stack direction='row' spacing={4}>
                            <Stack direction='row' spacing={0.7} alignContent={'end'} alignItems={'end'}>
                                <Typography variant="body1" component="div">
                                    跟进方式
                                </Typography>
                                <Chip size="small" sx={{border: ' none'}} color={'secondary'} variant={'outlined'} label={record.way}/>
                            </Stack>
                            <Stack direction='row' spacing={0.7} alignContent={'end'} alignItems={'end'}>
                                <Typography variant="body1" component="div">
                                    跟进内容
                                </Typography> <Chip size="small" sx={{border: ' none', fontWeight: 400}} color={'success'} label={record.type}/>
                            </Stack>
                        </Stack>
                    </CardActions>
                </Card>
            })}
        </Stack>


    </ResultWrapper>
    </>
}